module.exports = __webpack_public_path__ + "static/media/BackLeft.e564c7e0.jpg";